import styled from 'styled-components'
import { pxToRem } from 'styles/functions'

const getX = (type) => {
  switch (type) {
    case 'reverse':
      return `right: ${pxToRem(100)}`
    case 'close':
      return `left: ${pxToRem(20)}`
    default:
      return `right: ${pxToRem(20)}`
  }
}

const getIconSize = (type) => {
  switch (type) {
    case 'reverse':
    case 'close':
      return pxToRem(30)
    default:
      return pxToRem(55)
  }
}

const getButtonSize = (type) => {
  switch (type) {
    case 'reverse':
    case 'close':
      return pxToRem(50)
    default:
      return pxToRem(70)
  }
}

interface StyledCircleButtonProps {
  theme: any;
  $type: string
}
export const StyledCircleButton = styled.button<StyledCircleButtonProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: ${pxToRem(20)};
  ${({ $type }) => getX($type)};
  width: ${({ $type }) => getButtonSize($type)};
  height: ${({ $type }) => getButtonSize($type)};
  color: white;
  background-color: rgba(0, 0, 0, 0.4);
  border: ${pxToRem(2)} solid white;
  border-radius: 50%;
  z-index: 1;
  cursor: pointer;

  svg {
    width: ${({ $type }) => getIconSize($type)};
    height: ${({ $type }) => getIconSize($type)};
  }

  i {
    display: none;
  }
`
